var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"method-content"},[_c('p',[_vm._v(" Ao clicar em Finalizar, o QR Code e código serão exibidos na tela para que o pagamento seja efetuado. ")]),(_vm.discount)?_c('p',[_vm._v(" Pagando com PIX você ganha "),_c('strong',[_vm._v(_vm._s(_vm.discount)+" de desconto em itens selecionados.")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }